import React, { createContext, useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import Actions from "./CartActions/Actions";
import Cart from "./Cart/Cart";
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "./Home";
import { Model } from "../../../hooks";
import { action, API, controller } from "../../../api/api";
import { lsDelete, lsGet, RandomCode } from "../../../hooks/Method";
import Checkout from "./Checkout/Checkout";
// import useInventoryCheck from "../Hooks/useInventoryCheck";

export const CartContext = createContext({});

const POS = () => {
  const { SellMdl } = Model();
  const [cartData, setCartData] = useState(SellMdl);
  const navigate = useNavigate();
  // Quate Sale
  const quoteSaleId = lsGet("quoteSaleId");
  // Processing Sale, Like OnAccount and Layby
  const procSaleId = lsGet("procSaleId");

  const mapDataWithCartState = (value) => {
    setCartData((j) => ({
      ...j,
      id: value.invoiceId,
      type: value.type,
      received: value.received || 0,
      payments: value.payments
        ? value.payments.map((p) => ({
            ...p,
            key: RandomCode(15),
            name: p.payType?.name,
            newPayment: false,
          }))
        : [],
      customerId: value.customerId || "",
      customer: value.customer || "",
      quoteSaleId: value.quoteSaleId || "",
      note: value.note || "",
      disType: value.disType || 1,
      disAmt: value.disAmt || "",
      discount: value.discount || "",
      sellItems: [
        ...value.items.map((item) => ({
          key: RandomCode(15),
          ...item,
          id: "",
          disAmt: item.disAmt || "",
          disableInvCheck: true,
        })),
      ],
    }));
  };

  // if continue quote sale then run this action
  useEffect(() => {
    if (quoteSaleId) {
      API(controller.QuoteSale + action.GetById).getById(quoteSaleId, (res) => {
        if (res && res.status === 200 && res.result.id) {
          var result = res.result;
          mapDataWithCartState({
            ...result,
            quoteSaleId: result.id,
            items: result.quoteItems,
          });
          lsDelete("quoteSaleId");
        }
      });
    } else if (procSaleId) {
      API(controller.Sell + action.GetById).getById(procSaleId, (res) => {
        if (res && res.status === 200 && res.result.id) {
          var result = res.result;
          mapDataWithCartState({
            ...result,
            items: result.sellItems,
            invoiceId: result.id,
          });
          lsDelete("procSaleId");
        }
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ----- check new cart item inventory is available or not -----
  // useInventoryCheck(cartData, setCartData);

  const handleClearCart = () => {
    navigate("/dashboard/sell");
  };

  return (
    <div>
      <CartContext.Provider value={{ cartData, setCartData }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <Box className="h-[calc(100vh-190px)] overflow-auto rounded-[8px]">
              <Routes>
                <Route
                  path="checkout"
                  element={
                    <Checkout
                      {...{
                        handleClearCart,
                      }}
                    />
                  }
                />

                <Route index element={<Home />} />
              </Routes>
            </Box>

            <div>
              <Actions />
            </div>
          </Grid>
          <Grid item xs={12} md={5}>
            <Cart />
          </Grid>
        </Grid>
      </CartContext.Provider>
    </div>
  );
};

export default POS;
